import { render, staticRenderFns } from "./TransparencyDashboard.vue?vue&type=template&id=d530ea12"
import script from "./TransparencyDashboard.vue?vue&type=script&lang=js"
export * from "./TransparencyDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports